import type { FC } from 'react';

import { cn } from '@repo/utils/common';

interface SIPLogoProps {
  className?: string;
}

/**
 * The SIP wordmark with its trademark glyph. Everything is drawn in
 * `currentColor`, the trademark included: the brand treats the glyph as part of
 * the mark, so it always takes the logo colour and there is deliberately no
 * knob to recolour it. A per-call-site override once existed and produced a bar
 * whose trademark changed colour at hydration (fe-monorepo-2k7x).
 */
export const SIPLogo: FC<SIPLogoProps> = ({ className }) => (
  <svg
    className={cn('text-primary', className)}
    fill="currentColor"
    viewBox="0 0 148 53"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M145.998 9.53307H147.548V0H145.206C144.744 0 144.645 0.0659612 144.513 0.527771L142.666 7.75181H142.435L140.588 0.527771C140.456 0.0659612 140.324 0 139.895 0H137.487V9.53307H138.972V1.51736H139.236L141.347 9.00529C141.479 9.43411 141.611 9.53307 142.04 9.53307H142.897C143.359 9.53307 143.491 9.43411 143.623 9.00529L145.734 1.51736H145.998V9.53307Z"
      fill="currentColor"
    />
    <path
      d="M133.034 1.35243H135.805V0H128.647V1.35243H131.451V9.56606H133.034V1.35243Z"
      fill="currentColor"
    />
    <path
      d="M119.774 30.4794C122.05 28.2364 123.171 25.6634 123.171 16.3283C123.171 7.32299 122.017 4.68407 119.774 2.408C117.959 0.527779 115.321 0 111.263 0H78.4417V9.40113H84.7751V43.2122H78.4417V52.7123H103.28V43.2122H96.5182V39.0229V32.8874V23.7832V13.6564V9.33515H106.513C108.69 9.33515 109.449 9.56605 109.911 9.9289C110.57 10.6876 110.801 11.7432 110.801 16.5592C110.801 21.3752 110.603 22.4308 109.911 23.1894C109.449 23.5523 108.69 23.7832 106.513 23.7832H100.081L102.687 32.8874H111.263C115.321 32.8874 117.959 32.3597 119.774 30.4794Z"
      fill="currentColor"
    />
    <path
      d="M47.1706 52.7123H72.2732V43.2122H65.544V9.40113H72.2732V0H47.1706V9.40113H53.8008V43.2122H47.1706V52.7123Z"
      fill="currentColor"
    />
    <path
      d="M13.1946 19.1981C12.5019 18.5713 12.4359 17.6147 12.4359 14.9758C12.4359 12.139 12.6008 10.6876 13.1286 10.1928C13.5904 9.73099 14.3491 9.66502 16.2953 9.66502H26.0923C28.2034 9.66502 28.8631 9.79696 29.3249 10.2588C29.8527 10.7865 30.0506 11.9081 30.2156 16.6581H41.5959C41.4309 7.38896 40.7382 4.51914 38.4951 2.27606C36.8458 0.626741 34.2729 0.0329742 29.7537 0.0329742H12.139C8.14764 0.0329742 5.67366 0.92361 4.09032 2.50696C1.68231 4.91497 0.692719 8.67542 0.692719 15.3717C0.692719 22.4967 1.35244 25.5975 3.3976 27.7086C5.04692 29.2919 7.22403 30.0506 10.8525 30.4135L26.2902 32.0628C28.4013 32.2937 29.4569 32.4916 29.9187 32.9534C30.6114 33.6132 30.6774 34.6027 30.6774 37.2417C30.6774 40.3754 30.5124 41.8268 29.9846 42.4205C29.4569 42.8823 28.5662 43.0143 26.3891 43.0143H15.7675C13.5244 43.0143 12.7657 42.7834 12.3039 42.3545C11.8421 41.8927 11.6442 40.6722 11.4793 35.4934H0C0.0659728 44.9275 0.824663 48.1602 3.00177 50.3373C4.81602 52.0855 7.35597 52.6793 11.8091 52.6793H30.7763C34.9986 52.6793 37.4066 51.7887 38.9899 50.2053C41.3979 47.7973 42.3875 44.0369 42.3875 36.8128C42.3875 29.6548 41.5629 26.4221 39.5177 24.377C37.9344 22.7936 35.8562 22.1009 32.2277 21.738L16.7901 20.0887C14.481 19.7918 13.6564 19.7259 13.1946 19.1981Z"
      fill="currentColor"
    />
  </svg>
);
